export enum TARGET_LINK {
  TARGET_BLANK = '_blank',
  TARGET_SELF = '_self',
}
